module.exports = __webpack_public_path__ + "images/d05952d98896b0ef763c6158f6bb2edc-Magic Village.png";